function toggleAccordion(id) {
  const content = document.getElementById(`content-${id}`);
  const icon = document.getElementById(`icon-${id}`);

  if (!content) {
    console.error(`No content element found for ID: content-${id}`);
    return;
  }

  if (!icon) {
    console.warn(`No icon element found for ID: icon-${id}`);
  }

  if (content.style.maxHeight && content.style.maxHeight !== '0px') {
    content.style.maxHeight = '0px';
    if (icon) {
      icon.classList.remove('rotate-180');
    }
  } else {
    content.style.maxHeight = content.scrollHeight + 'px';
    if (icon) {
      icon.classList.add('rotate-180');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const accordionButtons = document.querySelectorAll('button[data-accordion-toggle]');

  accordionButtons.forEach(button => {
    button.addEventListener('click', () => {
      const clickedId = button.getAttribute('data-accordion-toggle');

      accordionButtons.forEach(otherButton => {
        const otherId = otherButton.getAttribute('data-accordion-toggle');

        if (otherId !== clickedId) {
          const content = document.getElementById(`content-${otherId}`);
          const icon = document.getElementById(`icon-${otherId}`);

          if (content) {
            content.style.maxHeight = '0px';
          }
          if (icon) {
            icon.classList.remove('rotate-180');
          }
        }
      });

      toggleAccordion(clickedId);
    });
  });
});